import React, { ReactNode, useEffect, useState } from 'react';
import AccountDataForClosedAccount from '../../components/account/data/for-closed-account/AccountDataForClosedAccount';
import AccountVerificationKyc from '../../components/account/verification/kyc/AccountVerificationKyc';
import AuthInactivityModal from '../../components/auth/inactivity-modal/AuthInactivityModal';
import AuthLoginModal from '../../components/auth/login/modal/AuthLoginModal';
import AuthPayAndPlayModal from '../../components/auth/pay-and-play/modal/AuthPayAndPlayModal';
import AuthProfileValidator from '../../components/auth/profile-validator/AuthProfileValidator';
import BannerMessage from '../../components/banner-message/BannerMessage';
import ByodHeader from '../../components/byod/header/ByodHeader';
import CmsMessageModal from '../../components/cms/message-modal/CmsMessageModal';
import CoolbetFooter from '../../components/coolbet/footer/CoolbetFooter';
import CoolbetHeader from '../../components/coolbet/header/CoolbetHeader';
import CoolbetHeaderMobile from '../../components/coolbet/header/mobile/CoolbetHeaderMobile';
import CrmMessagePreview from '../../components/crm/message-preview/CrmMessagePreview';
import GeocomplyFeedback from '../../components/geocomply/feedback/GeocomplyFeedback';
import MobileWebCheckBanner from '../../components/mobile-web-check-banner/MobileWebCheckBanner';
import ResponsibleGaming from '../../components/responsible-gaming/ResponsibleGaming';
import ResponsibleGamingMultipleSessionModal from '../../components/responsible-gaming/multiple-session-modal/ResponsibleGamingMultipleSessionModal';
import ResponsibleGamingPanel from '../../components/responsible-gaming/panel/ResponsibleGamingPanel';
import ScrollToTop from '../../components/scroll-to-top/ScrollToTop';
import Toast from '../../components/toast/Toast';
import UiBottomNavigation from '../../components/ui/bottom-navigation/UiBottomNavigation';
import { useStore } from '../../hooks/useStore';
import { getClient, isBYOD } from '../../services/environment';
import { isFeatureAvailable } from '../../services/feature';
import { checkSourceType } from '../../services/mobile-app';
import { storageGet, storageSet } from '../../services/storage';
import { closeToast, closeToastsOnLogout } from '../../services/toast';
import { FEATURE } from '../../services/types';
import { stores } from '../../stores';
import { media } from '../../stores/media/media';
import Wrapper from './styles';
import { ClientName } from '../../services/utils/types';

interface Props {
    children: ReactNode;
}

export default function MainLayout({ children }: Props) {
    const [{ isDesktop, isLaptop, isTablet, isPhone }] = useStore(media);
    const [applicationType] = useStore(stores.applicationType);
    const [isPokerClient, setIsPokerClient] = useState(false);
    const [isAuthenticated] = useStore(stores.isAuthenticated);
    const [toasts] = useStore(stores.toasts);

    const forceHideMobileNav = window.location.search.includes('hideMobileNav') || storageGet<string>('hideMobileNav');

    if (forceHideMobileNav) {
        storageSet('hideMobileNav', true);
    }

    const displayWebHeader = isFeatureAvailable(FEATURE.HEADER) && checkSourceType() !== 'IOS' && !forceHideMobileNav;

    useEffect(() => {
        setIsPokerClient(applicationType === 'poker-download');
    }, [applicationType]);

    useEffect(() => {
        if (!isAuthenticated && toasts.length) {
            closeToastsOnLogout();
        }
    }, [isAuthenticated]);

    return (
        <Wrapper className="main" id="main-layout">
            <ResponsibleGamingPanel />
            {isBYOD() ? (
                <ByodHeader />
            ) : (
                displayWebHeader && (
                    <div className="header">
                        {(isDesktop || isLaptop) && <CoolbetHeader />}
                        {!isDesktop && !isLaptop && isFeatureAvailable(FEATURE.HEADER_MOBILE) && (
                            <CoolbetHeaderMobile />
                        )}
                    </div>
                )
            )}

            <BannerMessage />
            <ScrollToTop>
                <div className="main-container">
                    {!(isBYOD() && getClient() == ClientName.FONTAINEBLEAU) &&
                        isFeatureAvailable(FEATURE.MOBILE_WEB_APP_INSTALL) && <MobileWebCheckBanner />}
                    <ResponsibleGaming>{children}</ResponsibleGaming>
                    <CrmMessagePreview />
                    <CmsMessageModal />
                </div>
            </ScrollToTop>
            {applicationType !== 'poker-download' && (isPhone || isTablet) && !forceHideMobileNav && (
                <div className="main-phone-navigation">
                    <UiBottomNavigation />
                </div>
            )}
            <AuthLoginModal />
            <GeocomplyFeedback />
            <AuthPayAndPlayModal />
            {isFeatureAvailable(FEATURE.LOGIN) && <AuthInactivityModal />}
            {isFeatureAvailable(FEATURE.RESPONSIBLE_GAMING) && <ResponsibleGamingMultipleSessionModal />}
            {!isPokerClient && <AuthProfileValidator />}
            <AccountVerificationKyc />
            <AccountDataForClosedAccount />
            <Toast toasts={toasts} closeToast={closeToast} />
            {isFeatureAvailable(FEATURE.FOOTER) && <CoolbetFooter />}
        </Wrapper>
    );
}
